<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="基本信息" name="1">
      <info-item
        :title="['项目名称', '客户名称']"
        :data="[detail.projectName, detail.customerName]"
      ></info-item>
      <info-item
        :title="['机构编号', 'sourceid']"
        :data="[detail.orgCode, detail.projectSourceId]"
      ></info-item>
      <info-item
        :title="['上线日期', '导入截止日期']"
        :data="[detail.projectDetailVO.onlineDate, detail.projectDetailVO.importDeadline]"
      ></info-item>
      <info-item
        :title="['服务截止日期', '服务入口']"
        :data="[
          detail.projectDetailVO.serviceDeadline,
          detail.projectDetailVO.serviceEntry,
        ]"
      ></info-item>
      <info-item
        :title="['是否隔离', '热线号码']"
        :data="[detail.projectDetailVO.isSeparate, detail.projectDetailVO.lineNumber]"
      ></info-item>
      <info-item
        :title="['坐席身份', '核实身份要素']"
        :data="[detail.projectDetailVO.staffType, detail.projectDetailVO.authWay]"
      ></info-item>
      <info-item
        :title="['特殊规定约定', '域名']"
        :data="[detail.projectDetailVO.specialAgreement, detail.projectDetailVO.domain]"
      ></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[detail.salesmanName, detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item title="系统信息" name="2">
      <info-item
        :title="['创建人', '创建时间']"
        :data="[detail.createdName, detail.gmtCreated]"
      ></info-item>
      <info-item
        :title="['最后修改人', '最后修改时间']"
        :data="[detail.modifiedName, detail.gmtModifiedStr]"
      ></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "@/components/base/detail-info-item.vue";

export default {
  props: {
    detail: Object,
  },
  components: {
    InfoItem,
  },
  data() {
    return {
      activeNames: ["1", "2"],
    };
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
}
</style>
